/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsDoubleMiniRight: {
  name: 'chevrons-double-mini-right';
  data: string;
} = {
  name: 'chevrons-double-mini-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.354 5.646a.5.5 0 1 0-.708.708L6.293 8 4.646 9.646a.5.5 0 0 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2Zm4 0a.5.5 0 1 0-.708.708L10.293 8 8.646 9.646a.5.5 0 0 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2Z" fill="currentColor"/></svg>`,
};
